import { transform } from './transform';
import { expandShorthand } from './expandShorthand';
export const postcssPhysicalToLogical = () => {
    return {
        postcssPlugin: 'postcss-physical-to-logical',
        Rule(rule) {
            if (/\[dir(=[^\]]*)?\]/.test(rule.selector)) {
                return;
            }
            rule.walkDecls(decl => {
                const rules = expandShorthand(decl.prop, decl.value);
                if (rules.length > 1) {
                    decl.after(rules.map(item => item.join(':')).join(';'));
                    decl.remove();
                    return;
                }
                const [prop, value] = transform(decl.prop, decl.value);
                decl.prop = prop;
                decl.value = value;
            });
        },
    };
};
postcssPhysicalToLogical.postcss = true;
//# sourceMappingURL=postcss.js.map